import { render, staticRenderFns } from "./SelecaoItensPedido.vue?vue&type=template&id=1e201cd3&scoped=true"
import script from "./SelecaoItensPedido.vue?vue&type=script&lang=js"
export * from "./SelecaoItensPedido.vue?vue&type=script&lang=js"
import style0 from "./SelecaoItensPedido.vue?vue&type=style&index=0&id=1e201cd3&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e201cd3",
  null
  
)

export default component.exports